module.exports = __webpack_public_path__ + "img/logo-energias-renovables.d7241497.png";